import { BaseFilter, FILTER_DATA_KEY } from './base-filter';
import { SM } from '@models/base';
import { DelaultFilterFieldDefault } from './shared';

export class DefaultFilter extends BaseFilter<any> {

    visibleTemplates = 9;

    constructor(id: string, fns: string[], hidden?: boolean, name = 'Название', desc ='Фильтрует по названию') {
        super({
            id,
            name: 'Фильтр',
            fields: [
                new DelaultFilterFieldDefault(fns, name, desc, hidden) as any,
            ]
        });
    }

    match(o: any, values?: SM<string | string[]>): boolean {
        if (!this.fields || this.fields.length == 0 || !values) {
            return true;
        }
        const ev: SM<boolean> = {};
        for (const k of Object.keys(values)) {
            if (k == FILTER_DATA_KEY) {
                continue;
            }
            const v = values[k];
            if (!k || !this.fieldsMap[k]) {
                return false;
            }
            ev[v[0]] = true;
            if (!this.fieldsMap[k].match(o, v)) {
                return false;
            }
        }
        for (const f of this.fields) {
            if (f?.id && !ev[f.id]) {
                if (!this.fieldsMap[f.id].match(o, undefined)) {
                    return false;
                }
            }
        }
        return true;
    }

}
